import {
  SET_CURRENT_INDEX,
} from '../constants/actionTypes';

const setCurrentIndexAction = i => ({ type: SET_CURRENT_INDEX, payload: i});

export const setCurrentIndex = i => dispatch => dispatch(setCurrentIndexAction(i));



// WEBPACK FOOTER //
// ./src/actions/actionMode.js